<script>
    import { onMount } from "svelte";
    let apiData;

    import Checkbox from "./components/Checkbox.svelte";
    import Radio from "./components/Radio.svelte";
    import Number from "./components/Number.svelte";
    import Switch from "./components/Switch.svelte";
    import Sidebar from "./components/Sidebar.svelte";
    import LoadingScreen from "./components/LoadingScreen.svelte";
    import Button from "./components/Button.svelte";
    import { formUrl } from './store'
  import Modal from "./components/Modal.svelte";
    let url;
    formUrl.subscribe(value => url = value)

    let isMobile = false;

    console.log(window.location.origin);
    onMount(async () => {
        fetch(window.location.origin + "/wp-json/options/all")
        .then(response => response.json())
        .then(data => {
            console.log(data);
            apiData = data;
        }).catch(error => {
            console.log(error);
            return [];
        });
    });
    function checkWindowWidth() {
        if (window.innerWidth <= 900) {
            isMobile = true;
        } else {
            isMobile = false;
        }
    }
    checkWindowWidth();
    window.addEventListener('resize', checkWindowWidth);


</script>

{#if !apiData}
<LoadingScreen></LoadingScreen>
{:else}
<div class="form-wrapper">
<form id="mobox-form" method="post" action={url}>
    <h2>{apiData.room_text.titel}</h2>
    <p>{apiData.room_text.intro}</p>
    <section>
        {#each apiData.room as room, i}
        <Checkbox id={i} name={room.name} multiple={room.multiple}></Checkbox>
        {/each}
        <Modal boxOne={apiData.box_1} boxTwo={apiData.box_2}></Modal>
    </section>
    <h2>{apiData.type_text.titel}</h2>
    <p>{apiData.type_text.intro}</p>
    <section class="grid-2">
        {#each apiData.type as room, i}
        <Radio id={i} idName="type" name={room.name} icon={room.icon} instruction={room.instruction}></Radio>
        {/each}
    </section>
    <h2>{apiData.period_text.titel}</h2>
    <p>{apiData.period_text.intro}</p>
    <section class="grid-2">
        {#each apiData.period as room, i}
        <Radio id={i} idName="period" name={room.name} icon={room.icon} instruction={room.instruction}></Radio>
        {/each}
    </section>
    <h2>{apiData.preference_text.titel}</h2>
    <p>{apiData.preference_text.intro}</p>
    <section class="grid-2">
        {#each apiData.preference as room, i}
        <Radio id={i} idName="preference" name={room.name} icon={room.icon} instruction={room.instruction}></Radio>
        {/each}
    </section>
    <h2>{apiData.service_text.titel}</h2>
    <p>{apiData.service_text.intro}</p>
    <section class="grid-2">
        {#each apiData.service as room, i}
        <Radio id={i} idName="service" name={room.name} icon={room.icon} instruction={room.instruction}></Radio>
        {/each}
    </section>
    <h2>{apiData.extras_text.titel}</h2>
    <p>{apiData.extras_text.intro}</p>
    <section class="grid-2">
        {#each apiData.extras as room, i}
        <Switch id={i} name={room.name} instruction={room.instruction}></Switch>
        {/each}
    </section>
    {#if isMobile}
        <Button type="submit" text="Dit wordt 'm, volgende stap"></Button>
        <span class="tip">Klik op "Samenstelling" voor een overzicht</span>
    {/if}
</form>
<Sidebar></Sidebar>
</div>

{/if}
<style>
    
    .grid-2 {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 15px;
    }
    p {
        padding-bottom: 1.5rem !important;
    }

    h2 {
        font-weight: 700;
        color: rgba(0,63,49,1);
    }

    .form-wrapper {
        display: grid;
        grid-template-columns: 6fr 5fr;
    }

    form {
        padding: 50px;
    }

    section {
        margin-bottom: 60px;
    }

    .tip {
        margin-top: 1rem;
        opacity: .4;
        margin-bottom: 5rem;
        padding-bottom: 10rem !important;
    }

    @media (max-width: 900px) {
        section {
            margin-bottom: 30px;
        }
        .grid-2, .form-wrapper {
            grid-template-columns: 1fr;
        }
        form {
            padding: 20px;
            padding-bottom: 78px;
        }
    }
</style>